"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeCustomize = void 0;
var react_1 = __importDefault(require("react"));
var Section_1 = require("../components/Section");
var variables = "$size: (\n  b: 12px, // base size\n  growth: $b2_3, // exponential-growth's base\n  n: 10, // classes for pixel-based sizing\n  p: 10, // classes for percentage-based sizing\n);";
var SizeCustomize = function () { return (react_1.default.createElement(Section_1.Customize, { variables: variables })); };
exports.SizeCustomize = SizeCustomize;
